export const trapFocusInsideNotification = () => {
  const toastContainer = document.querySelector(".Toastify");
  const closeToastButton = toastContainer.querySelector(
    ".Toastify__close-button"
  );

  if (toastContainer && closeToastButton) {
    closeToastButton.focus();

    closeToastButton.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        e.preventDefault();
        closeToastButton.focus({ focusVisible: true });
      }
    });
  }
};
